import { useEffect, useState } from 'react'
import TextField from '@material-ui/core/TextField'
import DateTimePicker from '@material-ui/lab/DateTimePicker'
import { gql, useLazyQuery } from '@apollo/client'
import { Loading } from '../componentes/States'

import Table from '../componentes/Table'

const query = gql`
    query Reporte($start: String!, $end: String!, $modo: String!) {
        tunelKilogramos(start: $start, end: $end, modo: $modo) {
          value
          fecha
          total
        }
    }
`

export default function Kilogramos () {
  const [modo, setModo] = useState('registro')
  const [loadData, { data, loading }] = useLazyQuery(query)

  const [start, handleStart] = useState(new Date())
  const [end, handleEnd] = useState(new Date())

  function handleModo (ev) {
    setModo(ev.target.value)
  }

  useEffect(() => loadData({ variables: { start, end, modo } }), [start, end, modo, loadData])

  return (
    <div className='container'>
      <h2 className='text-center'>Reporte túnel KGs (por programa)</h2>
      <div className='row mt-4'>
        <div className='col-md-12'>
          <div className='well well-sm'>
            <div className='form-group form-row'>
              <div className='col-md-8'>
                <DateTimePicker
                  renderInput={(props) => <TextField className='w-50' {...props} />}
                  label='Inicio'
                  value={start}
                  onChange={handleStart}
                />
                <DateTimePicker
                  renderInput={(props) => <TextField className='w-50' {...props} />}
                  label='Fin'
                  value={end}
                  onChange={handleEnd}
                />
              </div>

              <div className='col-md-4'>
                <div className='form-check form-check-inline'>
                  <input className='form-check-input inputChange' type='radio' name='tipo' id='inlineRadio1' value='registro' defaultChecked onChange={handleModo} />
                  <label className='form-check-label' htmlFor='inlineRadio1'>Total</label>
                </div>
                <div className='form-check form-check-inline'>
                  <input className='form-check-input inputChange' type='radio' name='tipo' id='inlineRadio2' value='diario' onChange={handleModo} />
                  <label className='form-check-label' htmlFor='inlineRadio2'>Diario</label>
                </div>
                <div className='form-check form-check-inline'>
                  <input className='form-check-input inputChange' type='radio' name='tipo' id='inlineRadio3' value='mensual' onChange={handleModo} />
                  <label className='form-check-label' htmlFor='inlineRadio3'>Mensual</label>
                </div>
              </div>
            </div>
            <div id='root' className='table-responsive'>
              {loading && <Loading />}
              <Table
                columns={modo === 'registro' ? ['Programa', 'Total'] : ['Fecha', 'Programa', 'Total']}
                rows={data && data.tunelKilogramos}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
